<template>
  <div id="ieditoredit" >
    <div class="header">
      <el-row type="flex" justify="center" align="middle" :gutter="20" style="height:100%;">
        <el-col :xs="16" :sm="16" :md="14" :lg="10">
          <!-- <span class="header-tips"> -->
          <span class="header-tips fs-label" v-if="editForm.edittime">上次保存于 {{editForm.edittime}}</span><!-- </span> -->
        </el-col>
        <el-col :xs="6" :sm="6" :md="8" :lg="4">
          <span class="header-btn">
            <el-button @click="cancelForm" >取消</el-button>
            <el-button type="success" @click="submitForm('editForm')" >保存</el-button>
          </span>
        </el-col>
      </el-row>
    </div>

    <el-row type="flex" justify="center">
      <el-col :xs="24" :sm="24" :md="22" :lg="14">
        <div class="editor-content">
          <el-form :model="editForm" :rules="rules" ref="editForm" label-width="5rem">

           <el-form-item label="分类" required>
           <el-row type="flex" justify="start" :gutter="20">
              <el-col :span="4">
                <el-form-item prop="category">
                  <el-select v-model="editForm.category" placeholder="分类" @change="handleCategoryChange">
                    <el-option
                      v-for="item in formatCategory"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col class="el-item" :span="2">热度</el-col>
              <el-col :span="10">
                <el-form-item prop="hotindex">
                 <el-select v-model="editForm.hotindex" placeholder="热度" @change="handleHotChange">
                    <el-option
                      v-for="item in formatHotlist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            </el-form-item>


            <el-form-item label="标题" prop="title">
              <el-input v-model="editForm.title" placeholder="请输入标题" icon="circle-cross" :on-icon-click="handleTitleIconClick"></el-input>
            </el-form-item>

            <el-form-item label="内容" prop="content">
              <el-input
                type="textarea"
                :autosize="{ minRows: 10, maxRows: 20}"
                placeholder="请输入内容"
                v-model="editForm.content">
              </el-input>
              <!-- <markdown-editor v-model="editForm.content" :configs="configs" ref="markdownEditor"></markdown-editor> -->
            </el-form-item>


           <el-form-item label="内容来源" required>
              <el-col :span="6">
                <el-form-item prop="sourcefrom">
                  <el-select
                    v-model="editForm.sourcefrom"
                    multiple
                    :multiple-limit=1
                    @change="handleSfChange"
                    filterable
                    allow-create
                    placeholder="请选择内容来源">
                    <el-option
                      v-for="item in formatSourcefromlist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>

                </el-form-item>
              </el-col>
              <el-col class="el-item" :span="2">&nbsp;&nbsp;</el-col>
              <el-col :span="16">
                <el-form-item prop="sourceurl">
                  <!-- <el-input v-model="editForm.sourceurl" placeholder="详细网址" icon="circle-cross" :on-icon-click="handleSourceurlChange"></el-input> -->
                  <el-autocomplete

                    v-model="editForm.sourceurl"
                    :fetch-suggestions="querySearch"
                    placeholder="详细网址"
                    :trigger-on-focus="false"
                    @select="handleSelect"
                    icon="circle-cross"
                    :on-icon-click="handleSourceurlChange"
                  ></el-autocomplete>

                </el-form-item>
              </el-col>
            </el-form-item>

            <el-form-item label="封面图片" prop="cover">
              <el-input v-model="editForm.cover" placeholder="封面图片链接" icon="circle-cross" :on-icon-click="handleCoverChange"></el-input>
            </el-form-item>

            <el-form-item label="标签" prop="labels">
              <el-col :span="24" class="el-item">
                <el-tag
                  type="gray"
                  v-for="tag in editForm.labels"
                  :key="tag.id"
                  :closable="true"
                  :close-transition="false"
                  @close="handleLabelClose(tag)"
                  class="editor-content-tags"
                >
                {{tag}}
                </el-tag>
                <el-button class="button-new-tag" size="small" @click="reqRcmdLabels">获取推荐标签</el-button>
              </el-col>
            </el-form-item>

            <el-form-item label="" prop="newlabels">
              <el-col :span="24" class="el-item">
                <el-tag
                  type="gray"
                  v-for="newtag in editForm.newlabels"
                  :key="newtag.id"
                  :closable="true"
                  :close-transition="false"
                  @close="handleClose(newtag)"
                  class="editor-content-tags"
                >
                {{newtag}}
                </el-tag>
                <el-input
                  class="input-new-tag"
                  v-if="inputVisible"
                  v-model="inputValue"
                  ref="saveTagInput"
                  size="mini"
                  @keyup.enter.native="handleInputConfirm"
                  @blur="handleInputConfirm"
                >
                </el-input>
                <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 新标签</el-button>
              </el-col>
            </el-form-item>
          </el-form>

        </div>
      </el-col>

    </el-row>

  </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import { Message } from 'element-ui'
    // import { markdownEditor } from 'vue-simplemde';
    import { newsType, hotsType, newsPlatform, newsPlatformType, newsListAddr } from '../../config/config'
    import { getNowTime, cloneObj } from '../../utils/com.js'
    import '../../static/style/ieditor/edit.scss'

    const defaultRcmdBtnName = '点击获取推荐标签', loadingRcmdBtnName = '标签获取中……'
    export default {
        data: function(){
            return {
              rules: {
                category: [
                  { required: true, message: '请选择分类', trigger: 'change' }
                ],
                hotindex: [
                  { required: true, message: '请选择热度', trigger: 'change' }
                ],
                title: [
                  { required: true, message: '请输入标题', trigger: 'blur' },
                  { min: 3, max: 100, message: '长度在 3 到 100 个字符', trigger: 'blur' }
                ],
                content: [
                  { required: true, message: '请填写内容', trigger: 'blur' }
                ],
                sourcefrom: [
                  { required: true, message: '请选择来源'},
                  { type: 'array', message: '来源必须为列表'}
                  // { required: true, message: '请选择来源', trigger: 'change' },
                  // { type: "array", required: true, len: 1,
                  //   fields: {
                  //     0: {type: "string", required: true},
                  //   }
                  // }
                ],
                sourceurl: [
                  { required: true, message: '请填写来源地址', trigger: 'blur' },
                  { type: 'url', message: '来源地址必须为url'}
                ],
                cover: [
                  // { required: true, message: '请填写封面图片地址', trigger: 'blur' },
                  { type: 'url', message: '来源地址必须为url'},
                  { min: 0, max: 256, message: '长度必须在 256 个字符以内', trigger: 'blur' }
                ],
                // newlabels: [
                //   {required: true, message: '请至少填写一个标签'}
                // ]
                // newlabels: [
                //   { type: 'array', required: true, message: '请至少填写一个标签', trigger: 'change' }
                // ]

              },


                value: '',
                editForm: {
                  labels: [],
                  newlabels: [],
                  id: '',
                  category: '',
                  title: '',
                  content: '',
                  hotindex: '',
                  cover: '',
                  sourcefrom: [],
                  sourceurl: '',
                  editor: null,
                  date: null,
                  edittime: null,
                  tip: '',
                },

                dynamicTags: [],
                inputVisible: false,
                inputValue: '',
                rcmdLabelsText: defaultRcmdBtnName,
                rcmdBtnLoading: false,
                inputMinSize: 2,
                tag: '',
                newtag: '',
                oldCategory: '',
                restaurants: [],
                // configs: {
                //     autofocus: true,
                //     autosave: {
                //       enabled: true,
                //       uniqueId: 'MyUniqueID20151217',
                //       delay: 6000
                //     },
                //     status: true,
                //     status: ['autosave', 'lines', 'words', 'cursor', {
                //       className: 'keystrokes',
                //       defaultValue: function(el) {
                //         this.keystrokes = 0
                //         el.innerHTML = '0 Keystrokes'
                //       },
                //       onUpdate: function(el) {
                //         el.innerHTML = ++this.keystrokes + ' Keystrokes'
                //       }
                //     }],
                //     initialValue: '',
                //     renderingConfig: {
                //         codeSyntaxHighlighting: true,
                //         highlightingTheme: 'atom-one-light'
                //     },
                //     showIcons: ['clean-block', 'horizontal-rule'],
                //     hideIcons: ['side-by-side', 'fullscreen'],
                //     shortcuts: true
                // }
            }
        },
        computed: {
          ...mapGetters({
              // 映射 this.newsdata 为 store.getters.newContent
              newContent: 'newContent',
              newsdata: 'newsdata',
              newstotal: 'newstotal',
          }),
          formatCategory(){
            let typelists = [];
            for(let i in newsType){
              let typelist = {}
              typelist.value = i;
              typelist.label = newsType[i];
              typelists.push(typelist);
            }
            console.debug("formatCategory> typelists:%o", typelists);
            return typelists;
          },
          formatHotlist(){
            let hotlists = [];
            for(let i in hotsType){
              let hotlist = {}
              hotlist.value = i;
              hotlist.label = hotsType[i];
              hotlists.push(hotlist);
            }
            console.debug("formatHotlist> hotlists:%o", hotlists);
            return hotlists;
          },
          formatSourcefromlist(){
            let sflists = [];
            for(let i in newsPlatform){
              let sflist = {}
              sflist.value = newsPlatform[i]; //i;
              sflist.label = newsPlatform[i];
              sflists.push(sflist);
            }
            if(this.newContent.sourcefrom && this.newContent.sourcefrom !== '1' && this.newContent.sourcefrom != '2'){
              let users = sflists.filter(user => {
                // console.debug("formatSourcefromlist> user.label:%o, sourcefrom:%o", user.label, this.newContent.sourcefrom);
                if (this.newContent.sourcefrom && user.label.indexOf(this.newContent.sourcefrom) === -1) return false;
                return true;
              });
              // console.debug("formatSourcefromlist> users:%o, length:%o", users, users.length);
              if(users.length === 0){
                let sl = {}
                sl.value = this.newContent.sourcefrom;
                sl.label = this.newContent.sourcefrom;
                sflists.push(sl);
              }
            }
            // console.debug("formatSourcefromlist> sflists:%o", sflists);
            return sflists;
          }

        },
        mounted() {
          this.restaurants = this.loadAll();
        },
        created() {
          this.id = this.$route.query.id || '';
          let index = this.$route.query.index || 0;
          this.index = parseInt(index);
          console.debug("created> id:%o, index:%o, newsdata:%o, newstotal:%o", this.id, this.index, this.newsdata, this.newstotal);
          if(this.id && this.newsdata){
            let item = this.reqNewsContent(this.id, this.newsdata);
            console.debug("created> item:%o", item);
            if(item){
              this.updateNewsContent(item);
            }
          }


          console.debug("created> newContent:%o", this.newContent);
          if(this.newContent && this.$store.state.route.query.id && this.$store.state.route.query.id === this.newContent.id){
            this.editForm = cloneObj(this.newContent);
            //remove empty array
            let nl = this.newContent.labels.split('#')||[];
            nl = nl.filter(t => t!=undefined && t!==null && t !=='');
            this.editForm.labels = nl;
            this.editForm.newlabels = [];
            this.editForm.id = this.newContent.id;
            // this.editForm.category = newsType[this.newContent.category];
            this.editForm.category = this.newContent.category+'';
            this.editForm.title = this.newContent.title;
            this.editForm.content = this.newContent.content;
            this.editForm.hotindex = this.newContent.hotindex+'';//hotsType[this.newContent.hotindex];
            this.editForm.cover = this.newContent.cover;
            // this.editForm.sourcefrom = ( this.newContent.sourcefrom!=='1'&&this.newContent.sourcefrom!=='2' ) ? newsPlatformType[this.newContent.sourcefrom] : this.newContent.sourcefrom;
            console.debug("created> before editForm:%o, newContent:%o", this.editForm, this.newContent);
            this.editForm.sourcefrom = [];
            // this.editForm.sourcefrom.push('福建新闻');
            ( this.newContent.sourcefrom==='1'||this.newContent.sourcefrom==='2' ) ? this.editForm.sourcefrom.push(newsPlatform[this.newContent.sourcefrom]) : this.editForm.sourcefrom.push(this.newContent.sourcefrom);
            // this.editForm.sourcefrom = this.editForm.sourcefrom.push(this.newContent.sourcefrom);
            console.debug("created> after editForm:%o, newContent:%o", this.editForm, this.newContent);
            this.editForm.sourceurl = this.newContent.sourceurl;
            this.editForm.editor = this.newContent.editor;
            this.editForm.date = this.newContent.date;
            this.editForm.edittime = this.newContent.edittime
            this.editForm.tip = this.newContent.tip
            this.oldCategory = this.editForm.category;
            console.debug("created> editForm:%o, dynamicTags:%o, oldCategory:%o", this.editForm, this.dynamicTags, this.oldCategory);
          }
          else{
            this.editForm.tip = '';
          }
          console.debug("created> editForm:%o", this.editForm);
          if(this.editForm.tip){
            Message({
              showClose: true,
              duration: 0,
              message: `驳回理由: ${ this.editForm.tip }`,
              type: 'warning'
            });
          }
        },
        destroyed(){
          Message.closeAll();
        },
        methods: {
          ...mapActions({
            // 映射 this.editNewsContent() 为 this.$store.dispatch('editNewsContent')
            editNewsContent: 'editNewsContent',
            addNewsContent: 'addNewsContent',
            getNewLables: 'getNewLables',
            updateNewsContent: 'updateNewsContent',
          }),

          handleSfChange(item){
            console.log("handleSfChange> item:%o, sourcefrom:%o", item, this.editForm.sourcefrom);
          },
          handleSelect(item) {
            console.log(item);
            this.editForm.sourceurl = item.sourceurl;
            this.editForm.sourcefrom = [];
            this.editForm.sourcefrom.push(item.value);
          },
          querySearch(queryString, cb) {
            var restaurants = this.restaurants;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            console.debug("querySearch> results:%o, queryString:%o", results, queryString);
            if(results.length > 0){
              results[0].sourceurl = queryString;
            }
            cb(results);
            console.debug("querySearch> sourceurl:%o", this.editForm.sourceurl);
          },
          createFilter(queryString) {
            return (restaurant) => {
              // return (restaurant.address.indexOf(queryString.toLowerCase()) === 0);
              console.debug("createFilter> %o", queryString.indexOf(restaurant.address));
              return (queryString.indexOf(restaurant.address) >= 0);
            };
          },
          loadAll() {
            return newsListAddr;
            // return [
            //   { "value": "腾讯新闻", "address": "qq.com" },
            //   { "value": "新浪新闻", "address": "sina.com.cn" },
            //   { "value": "中新网", "address": "chinanews.com" },
            //   { "value": "凤凰网", "address": "ifeng.com" },
            //   { "value": "人民网", "address": "people.com.cn/" },
            //   { "value": "网易新闻", "address": "163.com" },
            //   { "value": "今日头条", "address": "toutiao.com" }
            // ];
          },

          reqNewsContent(id, datalist) {
            console.debug('reqNewsContent> id:%o, datalist:%o', id, datalist);
            if(!id || !datalist){
              return false;
            }
            let data = null;
            let hasUser = datalist.some(u => {
              if (u.id === id ) {
                data = JSON.parse(JSON.stringify(u));
                return true;
              }
            });
            console.debug("reqNewsContent> hasUser:%o, data:%o", hasUser, data);
            return data;
          },
          handleCategoryChange(val){
            console.debug("handleCategoryChange> val:%o, category:%o", val, this.editForm.category);

            console.debug("handleCategoryChange> editForm.labels:%o, newsType[%o]:%o", this.editForm.labels, this.oldCategory, newsType[this.oldCategory]);
            // if(this.editForm.labels.length>0 && newsType[this.oldCategory]){
              console.debug("handleCategoryChange> before labels:%o", this.editForm.labels);
              this.editForm.labels = this.editForm.labels.filter(t => t !== newsType[this.oldCategory]);
              this.editForm.labels.push(newsType[this.editForm.category]);
              console.debug("handleCategoryChange> after labels:%o", this.editForm.labels);
            // }
            this.oldCategory = this.editForm.category;
          },
          handleHotChange(val){
            console.debug("handleHotChange> val:%o, hotindex:%o", val, this.editForm.hotindex);
          },
          handleSourcefromChange(val){
            console.debug("handleSourcefromChange> val:%o", val);
          },
          handleSourceurlChange(val){
            console.debug("handleSourceurlChange> val:%o", val);
            this.editForm.sourceurl = '';
          },
          handleCoverChange(val){
            console.debug("handleCoverChange> val:%o", val);
            this.editForm.cover = '';
          },

          reqRcmdLabels() {
            if(!this.editForm.title || !this.editForm.content){
              let msg = '标题 或 内容 不能为空。'
              this.$message({
                    message: msg,
                    type: 'warning'
                });
              return false;
            }
            var that = this;
            let param = {
                content: this.editForm.title + this.editForm.content,
            }
            this.rcmdBtnLoading = true;
            this.rcmdLabelsText = loadingRcmdBtnName;
            console.debug("reqRcmdLabels> getNewLables> param:%o", param);
            this.getNewLables(param).then(
              (resp) => {
                console.debug("reqRcmdLabels> getNewLables> resp:%o", resp);
                that.rcmdBtnLoading = false;
                that.rcmdLabelsText = defaultRcmdBtnName;
                if(resp && resp.code !== 0){
                  that.$message({
                        message: resp.msg,
                        type: 'error'
                    });
                }else{
                  let nl = [], rnl = [];
                  // if(this.newContent.labels){
                  //   nl = this.newContent.labels.split('#');
                  //   nl = nl.filter(t => t!=undefined && t!==null && t !=='');
                  // }
                  nl = this.editForm.labels;
                  // console.debug("reqRcmdLabels> nl:%o", nl);
                  if(resp.data.labels){
                    rnl = resp.data.labels.split('#');
                    rnl = rnl.filter(t => t!=undefined && t!==null && t !=='');
                  }
                  // console.debug("reqRcmdLabels> rnl:%o", rnl);
                  if(this.editForm.category){
                    nl.push(newsType[this.editForm.category]);
                  }
                  nl = nl.concat(rnl);
                  console.debug("reqRcmdLabels> before nl:%o", nl);
                  nl = this.arryDerep(nl); //nl.derep();
                  console.debug("reqRcmdLabels> after nl:%o", nl);
                  this.editForm.labels = nl;
                }
              }
            );
          },

          handleLabelClose(tag) {
            this.editForm.labels.splice(this.editForm.labels.indexOf(tag), 1);
            // console.debug("handleLabelClose> tag:%o, labels:%o, ", tag, this.editForm.labels);
          },

          handleClose(tag) {
            this.editForm.newlabels.splice(this.editForm.newlabels.indexOf(tag), 1);
            // console.debug("handleClose> tag:%o, newlabels:%o, ", tag, this.editForm.newlabels);
          },

          showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
              this.$refs.saveTagInput.$refs.input.focus();
            });
          },

          handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
              this.editForm.newlabels.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = '';
          },
          cancelForm() {
            this.$router.go(-1);
          },
          submitForm(formName){
            console.debug("submitForm> formName:%o, editForm:%o", formName, this.editForm);
            this.$refs[formName].validate((valid) => {
              if (valid) {
                let params = cloneObj(this.editForm);
                let nl = params.newlabels;
                let l = params.labels;
                l = l.concat(nl);
                l.push(newsType[params.category]);
                console.debug("submitForm> before l:%o", l);
                l = this.arryDerep(l); //l.derep();
                console.debug("submitForm> after l:%o", l);

                params.newlabels = params.newlabels.join('#');
                params.labels = l.join('#');
                params.sourcefrom = params.sourcefrom[0]//newsPlatform[params.sourcefrom];

                console.debug("submitForm> id:%o, newlabels:%o, labels:%o", params.id, params.newlabels, params.labels);
                if(params.id){
                  this.editNewsContent(params).then(
                    (resp) => {
                    console.debug("editNewsContent> resp:%o", resp);
                      if(resp.code === 0){
                          this.$message({
                              message: resp.msg,
                              type: 'success'
                          })
                          console.debug("editNewsContent> newContent:%o", this.newContent);
                          this.$router.push({ path: './review',query: { id: this.newContent.id }})
                      }else{
                        this.$message({
                              message: resp.msg,
                              type: 'error'
                          })
                      }
                    }
                  );
                }else{
                  params.edittime = getNowTime('yyyy-mm-dd hh:mm:ss');
                  this.addNewsContent(params).then(
                    (resp) => {
                    console.debug("addNewsContent> resp:%o", resp);
                      if(resp.code === 0){
                          this.$message({
                              message: resp.msg,
                              type: 'success'
                          })
                          console.debug("addNewsContent> newContent:%o", this.newContent);
                          this.$router.push({ path: './review',query: { id: this.newContent.id }})
                      }else{
                        this.$message({
                              message: resp.msg,
                              type: 'error'
                          })
                      }
                    }
                  );
                }
              } else {
                console.log('error submit!!');
                return false;
              }
            });

          },
          reviewText(id){
            //location.href = './review';
            this.$router.push({ path: './review',query: { id }})
          },
          handleTitleIconClick() {
            this.editForm.title = '';
          },

          arryDerep(arry){
              var res = [];
              var json = {};
              for(var i = 0; i < arry.length; i++){
                  if(!json[arry[i]]){
                      res.push(arry[i]);
                      json[arry[i]] = 1;
                  }
              }
              return res;
          }

        },
        components: {
            // markdownEditor
        }
    }
</script>
<style scoped>
    .editor-btn{
        margin-top: 20px;
    }

    .header{
        background: white;
        /*padding: 0 20%;*/
        height: 60px;
        border: 1px solid #939393;
        /*border-style: solid dotted dashed double;*/
        border-top: none;
        border-left: none;
        border-right: none;
        /*display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;*/
        position: fixed;
        z-index: 1;
        width: 100%;
    }
    .header .header-tips{
      /*font-size: 10px;*/
      color: #939393;
      /*width: 80%;*/
      /*border: 1px solid black;
      display: inline-flex;
      flex-direction: row;
      justify-content: flex-start;*/
    }
    .header .header-tips .header-tips-audio{
      /*border: 1px solid blue;*/
      width: 500px;
    }
    .header .header-btn{
      /*border: 1px solid black;*/
      /*width: 150px;
      display: inline-flex;
      flex-direction: row;
      justify-content: space-between;*/

      /* border: 1px solid black; */
      /* width: 150px; */
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      margin: 8px 0;

    }

    .editor-content{
      /*border: 1px solid blue;*/
      margin: 0 auto;
      /*width: 60%;*/
      /*height: 600px;*/
      padding: 80px 10px;
      background: white;
    }

    .editor-content .editor-content-tags{
      margin: 0 5px;
    }
    .input-new-tag{
      width: 120px;
    }

    .el-autocomplete {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// edit.vue?a35e0338